var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesert2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 55,
    viewBox: "0 0 130 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9697 43.7968L14.9641 43.7888L6.16009 31.111C4.22436 28.3236 3.43012 24.9004 3.94067 21.5454L4.51874 17.7467C5.32938 12.4196 10.3858 8.81891 15.685 9.79508L16.4393 9.93403C20.8488 10.7463 25.3809 9.40318 28.6359 6.31957L29.7824 5.23334C31.4767 3.62823 33.9778 3.21695 36.0969 4.19498C37.1188 4.66663 38.2034 4.98842 39.3172 5.15043L58.9747 8.0097C63.5565 8.67615 68.1933 8.88483 72.8164 8.63266L84.4277 7.99931C89.8313 7.70457 95.1962 9.06634 99.8051 11.9026L107.604 16.7017C110.778 18.6552 114.649 19.1195 118.196 17.9722C122.544 16.5654 127 19.8074 127 24.3774V34.9957C127 44.0395 118.79 50.8629 109.899 49.2088L91.8289 45.8469C90.7688 45.6497 90 44.7247 90 43.6464V42.6771C90 35.6952 81.5586 32.1987 76.6217 37.1356C76.3595 37.3978 76.1162 37.6783 75.8938 37.975L74.6045 39.694C72.8442 42.0411 70.6593 44.0373 68.1631 45.579L62.8004 48.8913C59.1194 51.1649 54.5158 51.3418 50.6711 49.3575L50.3335 49.1832C44.7681 46.3107 38.0977 46.6006 32.8025 49.9449C27.5123 53.2861 20.5282 51.8567 16.976 46.706L14.9697 43.7968Z",
    stroke: "currentColor",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesert2);
export default __webpack_public_path__ + "static/media/desert2.46e5809c.svg";
export { ForwardRef as ReactComponent };